import { PlayerUtilitiesService } from './../../players/services/player-utilities.service';
import { switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { User } from '../../models/user';
import { Observable } from 'rxjs';
import { BaseHttpService } from '../../shared/base.httpservice';
import { HttpClient, HttpContext } from '@angular/common/http';
import { SILENT_ERRORS } from '../../shared/interceptors/httperror.interceptor';

@Injectable()
export class AuthHttpService extends BaseHttpService {
	protected readonly endpoint = this.apiUrl('auth');

	constructor(public http: HttpClient, private playerUtilitiesService: PlayerUtilitiesService) {
		super(http);
	}

	getCurrentUser(): Observable<User> {
		return this.http.get<User>(`${this.endpoint}/user`).pipe(
			switchMap(res => this.playerUtilitiesService.mapAsObservable(res))
		);
	}

	// ID-8: a new app-local anonymous user and its session token.
	startAnonymousSession(): Observable<{ anonymous_token: string }> {
		return this.http.post<{ anonymous_token: string }>(`${this.endpoint}/anonymous`, null);
	}

	// After a Pro Pool ID login (sent with that token): the account takes over this anonymous user (ID-8), or - without
	// one, e.g. registered at Pro Pool ID - gets its own app user on its first login (ID-6B).
	linkAnonymousUser(anonymousToken: string | null): Observable<{ linked: boolean, created: boolean }> {
		return this.http.post<{ linked: boolean, created: boolean }>(`${this.endpoint}/link`, { AnonymousToken: anonymousToken });
	}

	// ID-10: pulls name, avatar, language and time zone from Pro Pool ID into the app's copy and returns it.
	// Runs in the background (resume, login), so a failure keeps the copy without an error modal.
	refreshProfile(): Observable<User> {
		return this.http.post<User>(`${this.endpoint}/profile/refresh`, null, { context: new HttpContext().set(SILENT_ERRORS, true) }).pipe(
			switchMap(res => this.playerUtilitiesService.mapAsObservable(res))
		);
	}
}
